import { api } from "../data";

/**
 * Startseite nach dem Login (Start unter „/“, dorthin führt die Anmeldung ohne ?weiter=).
 * 0330 (Inhaber 16.10.2026): Plattform-Admins landen standardmäßig in der Betreiber-Konsole; mit der Einstellung
 * „Nach dem Login: Agentur“ (user_preferences.start_area = 'agentur') wie alle anderen in ihrer Agentur bzw. im Creator-Portal.
 * Doppelrolle Agentur und Creator: zuletzt genutzter Bereich (Befund 16).
 */
export type StartBereich = "betrieb" | "agentur";

export function startZiel(
  a: { isPlatformAdmin: boolean; startArea?: StartBereich | null; memberships: readonly unknown[]; talentLinks: readonly unknown[] },
  zuletzt: string | null,
): "/betrieb" | "/agentur" | "/creator" | null {
  if (a.isPlatformAdmin && a.startArea !== "agentur") return "/betrieb";
  if (a.memberships.length && a.talentLinks.length && zuletzt === "creator") return "/creator";
  if (a.memberships.length) return "/agentur";
  if (a.talentLinks.length) return "/creator";
  if (a.isPlatformAdmin) return "/betrieb";
  return null;
}

/** Wahl speichern (eigene Zeile in user_preferences, RLS: nur die eigene). Demo: in der Demo-Datenbank wie alles andere. */
export async function saveStartArea(userId: string, area: StartBereich): Promise<void> {
  const now = new Date().toISOString();
  const own = await api.select<{ user_id: string }>("user_preferences", { columns: "user_id", filters: [["user_id", "eq", userId]] });
  if (own.length) await api.update("user_preferences", [["user_id", "eq", userId]], { start_area: area, updated_at: now });
  else await api.insert("user_preferences", { user_id: userId, start_area: area }, { columns: "user_id" });
}
